module.exports = __webpack_public_path__ + "img/fake-user-8.fe005e75.png";